import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Lazy load WOW.js for better performance
const WowInit: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    let wowInstance: any;

    const initWOW = async () => {
      const { WOW } = await import("wowjs");
      wowInstance = new WOW({
        live: false,
        mobile: true,
        offset: 0,  
      });

      requestAnimationFrame(() => {
        wowInstance.init();
      });
    };

    initWOW();

    return () => {
      if (wowInstance && typeof wowInstance.sync === "function") {
        wowInstance.sync();
      }
    };
  }, [location.pathname]);

  return null;
};

export default WowInit;
